
export default {
  inject: ['bundle'],
  computed: {
    level1() {
      return {
        label: 'Home',
        link: '/',
      }
    },
    level2() {
      return {
        label: 'Lole Lookbook',
        link: `/${this.$i18n.locale}/s/lole-lookbook`,
      }
    },
    level3() {
      if (this.bundle.bundleTitle) {
        return {
          label: this.bundle.bundleTitle,
          link: '',
        }
      } else {
        return null
      }
    },
  },
}
